// import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

class stickyQuote {
    constructor() {
        this.events();
        this.stickThis();
        this.collapseInit();
    }

    collapseInit() {
        if ($(window).width() < 1025) {
            $(".president ~ .bullettext-l-image-r .bulletCollapse").removeClass('d-none');
            
            $( ".bullettext-l-image-r .bulletCollapse" ).click(function() {
                var collapseID = $(this).attr('data-target');

                if($("."+collapseID).hasClass('show')){
                    $(this).html('Read more');
                    $("."+collapseID).removeClass('show');
                }
                else{
                    $(this).html('Read less');
                    $("."+collapseID).addClass('show');
                }
            });
        }
    }

    stickThis() {
        var sticker = $('.bullettext-l-image-r .bullettext-l-image-r__img');
        var contentHeight = $('.bullettext-l-image-r__text ');
        var position = sticker.offset();
        $(window)
        .on('scroll', function () {
            var scrollDistance = $(window).scrollTop();
                if ($(contentHeight).innerHeight() > 900) {
                    if (scrollDistance >= position.top) {
                        sticker.addClass('bullettext-l-image-r__img--sticky');
                        sticker.removeClass('bottom');
                        sticker.addClass('top');
                    } else {
                        sticker.removeClass('bullettext-l-image-r__img--sticky');
                    }
                    if (scrollDistance >= position.top + $(sticker).innerHeight() - 400) {
                        sticker.removeClass('bullettext-l-image-r__img--sticky');
                        sticker.addClass('bottom');
                        sticker.removeClass('top');
                    }
                }
            })
            .trigger('scroll');
    }

    resizeEvents() {
        $(window).on('resize', () => {});
    }

    clickEvents() {}

    events() {
        this.clickEvents();
        this.resizeEvents();
    }
}

export default stickyQuote;
new stickyQuote();
